import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router';

import borrowBoxLogo from '../../img/BorrowBox_logo.png';
import './Maintenance.scss';

export const Maintenance = () => {
    const isMaintenanceRoute = useRouteMatch('/maintenance');

    useEffect(() => {
        if (!isMaintenanceRoute) {
            const redirectTimeout = setTimeout(() => document.location.reload(), 60 * 1000);
            return () => clearTimeout(redirectTimeout);
        }
    }, [isMaintenanceRoute]);

    return (
        <div className="maintenance">
            <img src={borrowBoxLogo} />
            <p>We are currently updating Connect. We will be back soon.</p>
        </div>
    );
};
